var _style, _defs, _clipPath, _g, _path, _defs2, _clipPath2, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFfb = function SvgFfb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ffb_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160.2 60",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".ffb_svg__st3{fill:#006193}")), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59.9v59.8H0z",
    style: {
      fill: "#b72f2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 19.2v-5.7H22.8v12.2h-3.9v3.9h3.9v3.1h-3.9v3.9h3.9v12h6.9v-12h6.1l1.8-3.9h-7.9v-3.1H39l1.7-3.9h-11v-6.5z",
    style: {
      fill: "#fff"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ffb_svg__SVGID_1_",
    d: "M0 0h160.2v60H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ffb_svg__SVGID_00000090268015365714310720000012717227545895638712_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ffb_svg__SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ffb_svg__SVGID_00000090268015365714310720000012717227545895638712_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffb_svg__st3",
    d: "M134.4 43.2h3.6c2.5 0 3.7-.2 4.8-1.1 1.2-1.1 1.9-2.7 1.8-4.3 0-2.2-.7-3.7-2-4.6-1.1-.7-2.2-1-5-1h-3.2v11zm0-17.1h3c4.4 0 6.4-1.8 6.4-5.5.1-1.8-.7-3.5-2.1-4.5-1.5-.6-3.1-.9-4.7-.8h-2.6v10.8zM138.6 9c4.4 0 7.2.7 9.1 2.3 2.3 2.2 3.6 5.3 3.4 8.5.1 2.5-.7 4.9-2.3 6.9-1 1.1-2.3 2-3.8 2.4 1.6.3 3.1 1 4.2 2.2 1.8 2 2.7 4.6 2.6 7.3 0 3.7-1.4 7.1-3.7 8.8-1.9 1.4-4.1 1.9-8 1.9h-13.2V9h11.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ffb_svg__st3",
    d: "M69.8 30.5V35h4v14.2h8.5V35h7.9l2.1-4.5h-10v-2.7h11.3l2.1-4.5H82.3v-7.6h13.4V9H73.8v14.3h-4v4.5h4v2.7zm52.5-14.8V9h-21.9v40.3h8.4V32.4h10.4l3.1-6.7h-13.5v-10z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ffb_svg__SVGID_00000039107425093404279850000010545766612624921266_",
    d: "M0 0h160.2v60H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ffb_svg__SVGID_00000155847163268020695490000000917241171985105802_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ffb_svg__SVGID_00000039107425093404279850000010545766612624921266_",
    overflow: "visible"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ffb_svg__SVGID_00000155847163268020695490000000917241171985105802_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ffb_svg__st3",
    d: "M149.9 57.4v-1.3h.4c.3 0 .6.2.7.6v.1c0 .4-.3.6-.7.6h-.4zm0 .9h.5c.8.1 1.6-.6 1.7-1.4v-.2c0-1-.6-1.5-1.7-1.5h-1.6v4.7h1.1v-1.6zm-6.7-3.1h-1.1v2.7c-.1.5.1 1.1.4 1.5.4.4.9.6 1.4.6.5 0 1-.2 1.4-.5.3-.4.5-1 .5-1.5v-2.7h-1.1V58c0 .2 0 .5-.1.7-.1.2-.4.3-.6.3-.2 0-.4-.1-.6-.3-.1-.2-.2-.5-.2-.7v-2.8zm-6.2 1c.8 0 1.4.6 1.4 1.3 0 .8-.6 1.4-1.3 1.4-.8 0-1.4-.6-1.4-1.3-.1-.7.5-1.4 1.2-1.4 0-.1 0-.1.1 0m0-1.1c-.6 0-1.3.2-1.7.7-.5.5-.8 1.1-.8 1.8.1 1.4 1.3 2.4 2.6 2.3 1.2-.1 2.2-1.1 2.3-2.3.1-1.3-.9-2.4-2.2-2.5h-.2m-7.4 2.3v-1.3h.4c.3 0 .6.2.7.6v.1c0 .4-.3.7-.7.7l-.4-.1zm0 .6 1 1.8h1.4l-1-1.7c.6-.2 1-.8.9-1.4 0-.5-.2-.9-.5-1.2-.4-.3-.9-.4-1.4-.3h-1.5v4.7h1.1V58zm-6.2-.8v.9h1.1c-.2.5-.7.8-1.2.8-.8 0-1.4-.6-1.3-1.4 0-.7.5-1.4 1.3-1.4h.1c.4 0 .8.2 1.1.5l.8-.7c-.5-.6-1.2-.9-2-.9-1.3-.1-2.5.9-2.6 2.3-.1 1.3.9 2.5 2.3 2.6h.3c.6 0 1.2-.2 1.7-.7.5-.5.8-1.1.8-1.8v-.2h-2.4zm-10.5.6 1.5-2.6h-1.3l-.7 1.4-.8-1.4h-1.3l1.5 2.6v2.1h1.1v-2.1zm-6-1.7h1.1v-.9h-3.3v.9h1.1v3.8h1.1v-3.8zm-4.8-.9H101v4.7h1.1v-4.7zm-5.3 3.7v-3.7h-1.1v4.7h2.6V59l-1.5-.1zm-5.5-2.8h1.5v-.9h-2.7v4.7h2.7V59h-1.5v-1h1.5v-.9h-1.5v-1zm-6.6 0h.2c.3 0 .7.1.9.3.3.3.4.7.4 1.1 0 .7-.5 1.4-1.3 1.4h-.3v-2.8zm-1.2 3.8H85c.6 0 1.2-.2 1.6-.5.5-.5.8-1.2.7-1.8 0-.7-.3-1.3-.8-1.8-.5-.4-1.1-.6-1.7-.5h-1.3v4.6zm-3-4.7h-1.1v4.7h1.1v-4.7zm-5.4.9h1.6v-.9H74v4.7h1.1V58h1.6v-.9h-1.5l-.1-1z"
  }))));
};

export default SvgFfb;